var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2 3.04997C22.3834 3.41663 21.4834 3.66663 20.5667 3.76663C21.5167 3.19997 22.25 2.29997 22.5834 1.21663C21.7 1.74997 20.7167 2.1333 19.6667 2.3333C18.8334 1.4333 17.6334 0.883301 16.3167 0.883301C13.7834 0.883301 11.7167 2.9333 11.7167 5.4833C11.7167 5.84997 11.75 6.19997 11.8334 6.5333C8.01671 6.34997 4.63338 4.51663 2.36671 1.7333C1.96671 2.41663 1.73338 3.19997 1.73338 4.04997C1.73338 5.64997 2.55005 7.04997 3.78338 7.86663C3.03338 7.84997 2.31672 7.6333 1.70005 7.29997C1.70005 7.31663 1.70005 7.3333 1.70005 7.34997C1.70005 9.5833 3.28338 11.4333 5.38338 11.85C5.00005 11.95 4.60005 12.0166 4.16672 12.0166C3.86672 12.0166 3.58338 11.9833 3.30005 11.9333C3.88338 13.7666 5.58338 15.0833 7.60005 15.1166C6.03338 16.35 4.05005 17.0833 1.90005 17.0833C1.53338 17.0833 1.16672 17.0666 0.800049 17.0166C2.83338 18.3333 5.25005 19.1 7.85005 19.1C16.3 19.1 20.9334 12.1 20.9334 6.01663C20.9334 5.81663 20.9334 5.61663 20.9167 5.41663C21.8 4.7833 22.5834 3.96663 23.2 3.04997Z",
  fill: "#00ACEE"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e58b2c33eecca2eefbc6b77bb9918981.svg";
export { ForwardRef as ReactComponent };